function getStorageValue(key) {
  const value = localStorage.getItem(key);

  if (!value) return null;

  try {
    let parsed = JSON.parse(value);

    if (Array.isArray(parsed)) {
      return parsed.join(',');
    }

    if (parsed && typeof parsed === 'object') {
      return Object.keys(parsed).map(function (id) {
        return parsed[id];
      }).join(',');
    }
  } catch (e) {
    return value;
  }

  return value;
}

function getAbsParams() {
  let absParams = '';

  function addAbsParam(name, value) {
    if (value) {
      absParams += '&' + name + '=' + encodeURIComponent(value);
    }
  }

  addAbsParam('cc_custom__abs_id', getStorageValue('abs-id'));
  addAbsParam('cc_custom__abs_groups', getStorageValue('abs-test-groups'));
  addAbsParam('cc_custom__abs_shipping_groups', getStorageValue('abs-shipping-test-groups'));
  addAbsParam('cc_custom__abs_redirect_groups', getStorageValue('abs-redirect-test-groups'));
  addAbsParam('cc_custom__abs_theme_groups', getStorageValue('abs-theme-test-groups'));
  addAbsParam('cc_custom__abs_template_groups', getStorageValue('abs-template-test-groups'));

  return absParams;
}

$(document).ready(function () {
  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });

  $(".product-selector_atc").click(function () {
      var $activeOuter = $(".product-selector_outer.active_block");
      var $activeBox = $activeOuter.find(".product-selector_block.active");

      var selectedIndex = $activeBox.index() + 1;
      var isSub = $activeOuter.attr("data") === "sub";

      var $config = $(".mp_coc_config--data");
      var domain = $config.attr("data-url");

      var productId = isSub
          ? $config.attr("data-sub-id-" + selectedIndex)
          : $config.attr("data-id-" + selectedIndex);

      // Current URL params (?utm_source=...&utm_medium=...)
      var params = window.location.search;

      var newUrl = domain + "?products=" + productId + getAbsParams();

      if (params) {
          newUrl += "&" + params.substring(1);
      }

      console.log(selectedIndex, isSub, productId, newUrl);

      window.location.href = newUrl;
  });
});
